function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-156.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-arrow-blue",
    transform: "translate(156.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.105 6.97 C 25.881 7.799 25.933 9.106 25.26 9.997 L 25.105 10.182 L 14.271 21.727 L 38.872 21.73 C 40.049 21.73 41.003 22.746 41.003 24 C 41.003 25.175 40.165 26.142 39.091 26.258 L 38.872 26.271 L 14.271 26.268 L 25.105 37.818 C 25.881 38.645 25.933 39.953 25.26 40.844 L 25.105 41.029 C 24.328 41.856 23.101 41.912 22.266 41.194 L 22.092 41.029 L 7.622 25.606 C 6.846 24.777 6.793 23.47 7.467 22.578 L 7.622 22.395 L 22.092 6.97 C 22.925 6.084 24.272 6.084 25.105 6.97 Z",
    id: "arrow",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(0, 1, -1, 0, 48.000144, -0.000808)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload-arrow.53f1db5540304cdcf93f8a072fa7f919.svg";
export { ForwardRef as ReactComponent };